module.exports = __webpack_public_path__ + "media/images/search-39b30743eb55aca1662a576ca6ab9901.png";